module.exports = __webpack_public_path__ + "img/online-experience-banner.b8d646a0.jpg";